import { secondAxios } from "./axios";
import paths from "./paths.api";

// Backend controller: @Controller('mis')
// GET /mis/plant/:plantId
// POST /mis/plant/:plantId

export const getPlantMis = async (plantId) => {
  if (!plantId) return null;
  try {
    const response = await secondAxios.get(`/mis/plant/${plantId}`);
    let payload = response.data;

    // Unwrap nested "data" properties until we reach the actual MIS JSON root
    // Supports shapes like { data: { data: { data: { invoices: {...} } } } }
    while (
      payload &&
      typeof payload === "object" &&
      "data" in payload &&
      Object.keys(payload).length === 1
    ) {
      payload = payload.data;
    }

    return payload ?? null;
  } catch (error) {
    // If MIS entry does not exist yet, treat as null so it can be created on save
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const upsertPlantMis = async (plantId, data) => {
  if (!plantId) throw new Error("plantId is required to save MIS data");
  // Send MIS JSON under "data" so NestJS service can store body.data in PlantMis.data
  const response = await secondAxios.post(`/mis/plant/${plantId}`, { data });
  return response.data;
};

